import React from "react";
import { useHistory } from "react-router-dom";
//Limitless imports
import { useCustomerMessageContext, useCustomerContext } from "@limitless/customer/hooks";

export const useCustomerAutoSubmit = () => {
    const [autoSubmit, setAutoSubmit] = React.useState({
        evaluating: true,
        autoSubmitLoading: false
    });
    const { customer, getCustomerData, isCustomerQuestionValid, addAutoSubmittedQuestion } = useCustomerContext();
    const { createMessage } = useCustomerMessageContext();

    const history = useHistory();

    React.useEffect(() => {
        if (customer.shouldAutoSubmit) {
            if (isCustomerQuestionValid() && !customer.autoSubmittedQuestions.includes(customer.question.value)) {
                setAutoSubmit({ evaluating: false, autoSubmitLoading: true });
                autoSubmitMessage();
            } else {
                setAutoSubmit({ ...autoSubmit, evaluating: false });
            }
        } else {
            setAutoSubmit({ ...autoSubmit, evaluating: false });
        }
    }, [customer.shouldAutoSubmit]);

    const autoSubmitMessage = () => {
        const customerData = getCustomerData();
        addAutoSubmittedQuestion(customerData.question);
        createMessage(customerData, newMsg => {
            history.push(`/conversation/${newMsg.messageId}/${newMsg.accessKey}/${false}`);
        });
    };

    return autoSubmit;
};
